<template>
  <div class="welcome">
    <div class="text-center">
      <Qrcode :width="200" :height="200" :text="text"></Qrcode>
    </div>
  </div>
</template>

<script>
import Qrcode from '../components/Qrcode'
export default {
  name: 'welcome',
  components: {
    Qrcode
  },
  data() {
    return {
      imgList: [],
      text: ''
    }
  },
  mounted() {},
  methods: {
    // 解析页面URL
    scanQRcode() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          console.log(result)
        }
      })
    }
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
.welcome {
  .img-box {
    display: flex;
    flex-wrap: wrap;
    .img {
      img {
        max-width: 200px;
      }
    }
  }
}
</style>
